import { createAsyncThunk } from '@reduxjs/toolkit';
import { GetProfileById } from './get-profile-by-id.thunk';

interface RemovePracticeProfileImageRequest {
    profileId: string;
    practiceProfileId: string;
    uploadId: number;
}

export const RemovePracticeProfileImage = createAsyncThunk(
    'profilesData/removePracticeProfileImage',
    async (
        request: RemovePracticeProfileImageRequest,
        { getState, dispatch }: any
    ) => {
        const axios = getState().core.axios;
        const { profileId, practiceProfileId, uploadId } = request;

        await axios.delete(
            `api/ProfilesData/PracticeProfileUploads/${profileId}/${practiceProfileId}/${uploadId}`
        );

        await dispatch(GetProfileById(profileId));
    }
);
